module.exports = __webpack_public_path__ + "static/media/sojka.673cca1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/installfest/resources/presenters/sojka.jpg
// module id = 470
// module chunks = 0